import { useLang } from "../i18n/LanguageContext";

export default function LanguageToggle() {
  const { lang, setLang, t } = useLang();
  return (
    <div
      className="inline-flex items-center gap-1 rounded-full border border-[#252525] bg-[#0f0f0f]/80 backdrop-blur p-1"
      data-testid="language-toggle"
    >
      <button
        type="button"
        onClick={() => setLang("es")}
        data-testid="lang-es-btn"
        className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all ${
          lang === "es"
            ? "bg-[#e8559a] text-white shadow-lg shadow-[#e8559a]/30"
            : "text-neutral-400 hover:text-white"
        }`}
      >
        🇲🇽 {t("spanish")}
      </button>
      <button
        type="button"
        onClick={() => setLang("en")}
        data-testid="lang-en-btn"
        className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all ${
          lang === "en"
            ? "bg-[#e8559a] text-white shadow-lg shadow-[#e8559a]/30"
            : "text-neutral-400 hover:text-white"
        }`}
      >
        🇺🇸 {t("english")}
      </button>
    </div>
  );
}
